const legalFoundationCategoryFilterOptions = [
    {
      "value": "FOUNDING_INSTRUMENTS",
      label: "Founding Instruments"
    },
    {
      "value": "TREATIES_AND_CONVENTIONS",
      label: "Treaties & Conventions"
    },
    {
      "value": "AFRICAN_UNION_DECISIONS",
      label: "African Union Decisions"
    },
    {
      "value": "STATUTES_AND_CHARTERS",
      label: "Statutes & Charters"
    },
    {
      "value": "POLICIES_AND_FRAMEWORKS",
      label: "Policies & Frameworks"
    },
    {
      "value": "REGULATIONS_AND_GUIDELINES",
      label: "Regulations & Guidelines"
    },
    {
      "value": "GOVERNANCE_DOCUMENTS",
      label: "Governance Documents"
    },
    {
      "value": "INSTITUTIONAL_MANDATES",
      label: "Institutional Mandates"
    },
    {
      "value": "AGREEMENTS_AND_MOUS",
      label: "Agreements & MoUs"
    },
    {
      "value": "MEMBER_STATE_INSTRUMENTS",
      label: "Member State Instruments"
    },
    {
      "value": "INTERNATIONAL_SPACE_LAW",
      label: "International Space Law"
    },
    {
      "value": "COMPLIANCE_AND_STANDARDS",
      label: "Compliance & Standards"
    },
    {
      "value": "STRATEGIC_LEGAL_DOCUMENTS",
      label: "Strategic Legal Documents"
    },
    {
      "value": "REPORTS_AND_RESOLUTIONS",
      label: "Reports & Resolutions"
    },
    {
      "value": "OTHER",
      label: "Other"
    }
  ]


export default legalFoundationCategoryFilterOptions;